import { MessageBar, MessageBarType, PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import React, { useState, useEffect } from 'react';
import Api from '../../services/Api'
import JSONInput from 'react-json-editor-ajrm/index';
import locale from 'react-json-editor-ajrm/locale/en';

const CustomApplicationsConfigPanel = () => {

    const [isLoading, setLoading] = useState(false)
    const [customApps, setCustomApps] = useState([])
    const [message, setMessage] = useState()
    const [isSaving, setSaving] = useState(false)
    const [jsonError, setJsonError] = useState(null)

    useEffect(() => {
        const fetchData = async () => {
            await getCustomApps();
        }
        fetchData();
    }, []);

    const getCustomApps = async () => {
        setLoading(true);
        try {
            const res = await Api.get('/Settings/CustomApplications');

            setCustomApps(res.data);
            setLoading(false);
        }
        catch(error) {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get Custom Applications settings from database: ' + error
            });
        }
    }

    const saveSettings = async () => {
        setMessage();

        if (jsonError)
            return;

        setSaving(true);
        
        try {
            await Api.post('/Settings/CustomApplications', customApps);

            setSaving(false);
            setMessage({
                type: MessageBarType.success,
                text: 'Settings have been saved.'
            });
            await getCustomApps();

        } catch (error) {
            setSaving(false);
            console.log(error);

            setMessage({
                type: MessageBarType.error,
                text: 'Cannot save settings: ' + error
            });
        };
    }

    // const onKeyDown = (e) => {
    //     if (e.key === 'Tab') {
    //         e.preventDefault()
    //         const textBox = e.target

    //         var start = textBox.selectionStart;
    //         var end = textBox.selectionEnd;
        
    //         // set textarea value to: text before caret + tab + text after caret
    //         textBox.value = textBox.value.substring(0, start) + "\t" + textBox.value.substring(end);
        
    //         // put caret at right position again
    //         textBox.selectionStart = textBox.selectionEnd = start + 1;
    //     }
    // }

    const onChange = (value, asd) => {
        if (!value.error) {
            setJsonError();
            setCustomApps(value.jsObject);
        } else {
            setJsonError(value.error);
        }
    }

    const msg = message && 
                <MessageBar messageBarType={message.type}>
                    {message.text}
                </MessageBar>

    const btn = isSaving
                ? <Spinner className='settings-btn' size={SpinnerSize.large} />
                : <PrimaryButton className='settings-btn' onClick={saveSettings}>Save</PrimaryButton>

    const infoTable =   <MessageBar messageBarType={MessageBarType.info} styles={infoTableStyles}>
                            <div>DO NOT change <samp>id</samp> property for updating entities. For adding new entity, do not include <samp>id</samp> property or set it to <samp>null</samp>.</div>
                            <div style={{marginTop: 10}}>
                                <div>JSON model for Custom Application entity:
                                    <samp style={{display: 'block'}}>
                                        {`{ id: int, name: string, iCarUrl: string, siteUrlMapping: string[] }`}
                                    </samp>
                                </div>
                                <div>Example:
                                    <samp style={{display: 'block'}}>
                                        {`{ id: 1, name: 'Test Application', iCarUrl: 'https://abb.sharepoint.com/sites/collhostingregistry/Lists/Applications/DispForm.aspx?ID=0', siteUrlMapping: ['Test_App_*'] }`}
                                    </samp>
                                </div>
                            </div>
                            <div style={{marginTop: 10}}>
                                <span><samp>siteUrlMapping</samp> supports the following wildcards:</span>
                                <li>? - Any single character</li>
                                <li>* - Zero or more characters</li>
                                <li># - Any single digit (0–9)</li>
                                <li>[charlist] - Any single character in charlist</li>
                                <li>[!charlist] - Any single character not in charlist</li>
                            </div>
                        </MessageBar>
        
    return (
        <div>
            {infoTable}
            {isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div className='settings-container'>
                    <JSONInput
                        placeholder={customApps}
                        theme='light_mitsuketa_tribute'
                        width='100%'
                        height='auto'
                        onBlur={onChange}
                        onKeyPressUpdate={false}
                        style={jsonInputStyle}
                        locale={locale}
                        error={jsonError}
                    />
                    {/* <TextField
                        value={customApps}
                        onChange={(e, val) => setCustomApps(val)}
                        onKeyDown={onKeyDown}
                        multiline
                        autoAdjustHeight
                        spellCheck={false}
                    /> */}
                    {btn}
                    {msg}
                </div>
            }
        </div>
    );
}

const jsonInputStyle = {
    body: {
        fontSize: '16px'
    }
}

const infoTableStyles = {
    innerText: {
        fontSize: 14,
        lineHeight: 20
    }
}

export default CustomApplicationsConfigPanel;



// WEBPACK FOOTER //
// ./src/components/Settings/CustomApplicationsConfigPanel.js